<div *ngIf="hasBusiness$|async">
  <h5 class="mt-0 mb-4 text-white font-weight-bold text-white">
    {{ "LandingPage.service-heading-business" | translate }}
  </h5>

  <div *ngIf="filing$|async" class="row pb-4">
    <div class="col-md-12">
      <h6 class="font-weight-bold text-white">
        {{ "LandingBusinessFilingPage.service-heading" | translate }}
      </h6>
      <p class="mb-2 text-white">
        {{ "LandingBusinessFilingPage.service-description" | translate }}
      </p>
      <div class="d-flex">
        <button (click)="onRedirect('/business/filings')"
            class="btn btn-theme-color pay-online btn-outline-secondary btn-sm py-1 rounded-0"
            tabindex="0"
            role="button"
            [attr.aria-label]="'Buttons.file-online-btn' | translate">
          {{ "Buttons.file-online-btn" | translate }}
        </button>
      </div>
    </div>
  </div>


  <div *ngIf="withholdings$|async" class="row pb-4">
    <div class="col-md-12">
      <h6 class="font-weight-bold text-white">
        {{ "LandingWithholdingPage.withholding-heading" | translate }}
      </h6>
      <p class="mb-2 text-white">
        {{ "LandingWithholdingPage.service-description" | translate }}
      </p>
        <p class="mb-2 text-white">
        {{ "LandingWithholdingPage.do-not-use-link-for-payments" | translate }}
      </p>
      <div class="d-flex">
        <button (click)="onRedirect('/business/withholding')"
            class="btn btn-theme-color pay-online btn-outline-secondary btn-sm py-1 rounded-0"
            tabindex="0" 
            role="button" 
            [attr.aria-label]="'Buttons.pay-file-online-btn' | translate">
          {{ "Buttons.pay-file-online-btn" | translate }}
        </button>
      </div>
    </div>
  </div>


  <div *ngIf="payments$|async" class="row pb-4">
    <div class="col-md-12">
      <h6 class="font-weight-bold text-white">
        {{ "LandingBusinessPaymentPage.business-heading" | translate }}
      </h6>
      <p class="mb-2 text-white">
        {{ "LandingBusinessPaymentPage.service-description" | translate }}
      </p>
      <div class="d-flex">
        <button (click)="onRedirect('/business/payments')"
            class="btn btn-theme-color pay-online btn-outline-secondary btn-sm py-1 rounded-0"
            tabindex="0" 
            role="button" 
            [attr.aria-label]="'Buttons.pay-online-btn' | translate">
          {{ "Buttons.pay-online-btn" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
